import styled, { css } from 'styled-components';
import { lightBaseTheme as lightBaseThemeWithLegacy } from '../theme/index.js';

const CompactPaymentWrapper = styled("div").withConfig({
    displayName: "styles__CompactPaymentWrapper",
    componentId: "sc-65a75c71-0"
})`
    display: flex;
    height: 29px;
`;
const IconWrapper = styled("span").withConfig({
    displayName: "styles__IconWrapper",
    componentId: "sc-65a75c71-1"
})`
    color: ${(props)=>props.theme.colors.Foreground};
    align-self: center;
    height: 24px;
`;
IconWrapper.defaultProps = {
    theme: lightBaseThemeWithLegacy
};
const DefaultWrapper = styled("div").withConfig({
    displayName: "styles__DefaultWrapper",
    componentId: "sc-65a75c71-2"
})`
    ${(props)=>css(props.theme.typography.Subheadline)}
    color: ${(props)=>props.theme.colors.Foreground};
    padding-left: ${(props)=>props.theme.spacers.L};
    align-self: center;
`;
const TightFitWrapper = styled(DefaultWrapper).withConfig({
    displayName: "styles__TightFitWrapper",
    componentId: "sc-65a75c71-3"
})`
    font-size: 16px;
    line-height: 19px;
`;
DefaultWrapper.defaultProps = {
    theme: lightBaseThemeWithLegacy
};

export { CompactPaymentWrapper, DefaultWrapper, IconWrapper, TightFitWrapper };
